import Link from 'next/link';
import styles from 'styles/modules/LoginInfo.module.scss';

const LoginInfo = ({ label, children }) => (
    <span
        className={styles.info}
        tabIndex={0}
        aria-label={label}
        data-nosnippet
    >
        i
        <span className={styles.popover}>
            <span>
                {children}{' '}
                <Link href="/login">
                    <a>Log in</a>
                </Link>
            </span>
        </span>
    </span>
);

export default LoginInfo;
